import * as yup from 'yup'

const schema = yup.object().shape({
  questionAlternativeId: yup.string().required(),
  hasJustification: yup.boolean(),
  justification: yup.string().when('hasJustification', {
    is: true,
    then: yup.string().required(),
  }),
})

export default schema
